import { useState } from 'react';
import { Box, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import { BasePageLayout } from '@/components/common';
import { SystemStatsCard, CacheManagementCard, DatabaseBackupCard, BackendLogsCard, RateLimitTab, ErrorCodesReferenceTab, SmtpSettingsCard } from './components';

export const AdminPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	return (
		<BasePageLayout>
			<Box sx={{ mb: 2.5 }}>
				<Typography variant="h4" component="h1" fontWeight={700} sx={{ mb: 0.75 }}>
					Hệ thống
				</Typography>
				<Typography variant="body1" color="text.secondary">
					Giám sát vận hành, cache, sao lưu dữ liệu, backend logs và cấu hình email.
				</Typography>
			</Box>

			<Paper
				variant="outlined"
				sx={{
					mb: 2.5,
					borderRadius: 1,
					overflowX: 'auto'
				}}
			>
				<Tabs
					value={activeTab}
					onChange={(_, value) => setActiveTab(value)}
					variant="scrollable"
					scrollButtons="auto"
					sx={{
						minHeight: 48,
						'& .MuiTab-root': {
							minHeight: 48,
							textTransform: 'none',
							fontWeight: 600
						}
					}}
				>
					<Tab label="Tổng quan" />
					<Tab label="Rate limit" />
					<Tab label="Logs" />
					<Tab label="Mã lỗi" />
					<Tab label="Email" />
				</Tabs>
			</Paper>

			<Box hidden={activeTab !== 0}>
				<Grid container spacing={2.5} alignItems="stretch">
					<Grid item xs={12}>
						<SystemStatsCard />
					</Grid>
					<Grid item xs={12} lg={6} sx={{ display: 'flex' }}>
						<Box sx={{ width: '100%', '& > .MuiCard-root': { height: '100%' } }}>
							<CacheManagementCard />
						</Box>
					</Grid>
					<Grid item xs={12} lg={6} sx={{ display: 'flex' }}>
						<Box sx={{ width: '100%', '& > .MuiCard-root': { height: '100%' } }}>
							<DatabaseBackupCard />
						</Box>
					</Grid>
				</Grid>
			</Box>

			<Box hidden={activeTab !== 1}>
				<RateLimitTab />
			</Box>

			<Box hidden={activeTab !== 2}>
				<BackendLogsCard />
			</Box>

			<Box hidden={activeTab !== 3}>
				<ErrorCodesReferenceTab />
			</Box>

			<Box hidden={activeTab !== 4}>
				<SmtpSettingsCard />
			</Box>
		</BasePageLayout>
	);
};
